/* unplugin-vue-components disabled */import { render } from "./TradePanel.vue?vue&type=template&id=7eed272e&scoped=true"
import script from "./TradePanel.vue?vue&type=script&lang=js"
export * from "./TradePanel.vue?vue&type=script&lang=js"

import "./TradePanel.vue?vue&type=style&index=0&id=7eed272e&scoped=true&lang=css"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eed272e"]])

export default __exports__